import React from "react"
import Container from "@ecom/ui/components/Container"
import { AppLinkButtonMui } from "@ecom/ui/components/AppLink"
import { Img } from "./Img"
import * as styles from "./banner.module.scss"

export const Banner = () => (
  <section>
    <Container className={styles.container}>
      <Img alt="bg img" className={styles.img} />
      <div className={styles.textBlock}>
        <h2 className={styles.title}>Национальная система рассрочек* «Халва»</h2>
        <div className={styles.subTitle}>Продавайте больше и экономьте на маркетинге</div>
        <AppLinkButtonMui className={styles.btn} href="https://halvaclub.ru/b2b">
          стать партнeром
        </AppLinkButtonMui>
      </div>
    </Container>
  </section>
)
